import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ListItem} from '../models/list-item';

@Component({
  selector: 'list-item-list',
  template: `
    <div class="row button-row">
      <div class="col-md-12 text-right">
        <button *ngIf="currentLid > 1" class="btn btn-sm btn-outline-primary" (click)="loadList.emit(1)">Back To System List</button>
        <a *ngIf="currentLid > 1" [routerLink]="['../editor', currentLid]">
          <span ><i class="fa fa-plus"></i> Add New List Item</span>
        </a>
      </div>
    </div>
    <div class="row header">
      <div class="col-md-2">Abbreviation</div>
      <div class="col-md-4">Title</div>
      <div class="col-md-4">Description</div>
      <div class="col-md-1">Active</div>
      <div class="col-md-1">&nbsp;</div>
    </div>
    <div *ngFor="let l of list">
      <div class="row line-item" *ngIf="l.abbreviation !== 'State'">
        <div class="col-md-2">
          <span *ngIf="l.parentLid == 1"><a (click)="loadList.emit(l.id)">{{l.abbreviation}}</a></span>
          <span *ngIf="l.parentLid != 1">{{l.abbreviation}}</span>
        </div>
        <div class="col-md-4">{{l.title}}</div>
        <div class="col-md-4">{{l.description}}</div>
        <div class="col-md-1 text-center">
          <input type="checkbox" [checked]="l.active" disabled/> </div>
        <div class="col-md-1 text-right"><a *ngIf="l.parentLid > 1"
               [routerLink]="['../editor', currentLid, l.id]"><i class="fa fa-pencil"></i> Edit</a></div>
      </div>
    </div>
  `,
  styles: [`
    .header {
      margin-bottom: 5px;
      border-bottom: 1px solid #666;
      font-weight:bold;
    }
    .line-item {
      border-bottom: 1px solid #ccc;
      margin-bottom:3px;
      padding-bottom:3px;
    }
    .button-row {
      margin-bottom:10px;
    }
  `]
})
export class ListItemListComponent {
  @Input() list: ListItem[];
  @Input() currentLid: number;
  @Output() loadList: EventEmitter<number> = new EventEmitter();

}




// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/components/list-item-list.ts